import { useEffect, useState } from 'react';
import { styles } from './Style.js';
import { KAGames } from './Games/KAGames.js';
import { KAGame  } from './Games/KAGame.js';

export function Games(props) {
    // We have to loop through KAGames and create a bunch of KAGame JSX elements
    const handleClick = (index) => { // program index

    }

    // These games should be sorted by score and votes
    // const games = KAGames.forEach(
    //         (game) => {
    //             localGames.push(<KAGamePreview data={game} handleClick={handleClick} />);
    //         }
    //     ).sort(
    //         (game) => {
    //             return game.score + (game.votes / 1000)
    //         }
    //     );

    useEffect(() => {
        const script = document.createElement('script');
      
        script.src = "./../node_modules/pixi.js/dist/browser/pixi.min.js";
      
        document.body.appendChild(script);
      
        return () => {
            document.body.removeChild(script);
        }
    });
    

    return (
        <div style={styles.Body}>
            <KAGame data={KAGames[0]} />
        </div>
    );
}